import { useAppDispatch, useAppSelector } from "../../../stores/hooks/hooks.ts";
import { useEffect } from "react";
import { RevSpinner } from "@revmatics/catalyst";
import { fetchProfileData } from "../../../stores/thunks/profileThunk.tsx";
import { ProfileSettingsPage } from "./ProfileSettingsPage.tsx";

export const ProfileSettingsWrapperPage = () => {
  const profile = useAppSelector((state) => state.profile.profile);
  const isLoading = useAppSelector((state) => state.profile.isLoading);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!profile) {
      dispatch(fetchProfileData());
    }
  }, [dispatch, profile]);

  if (isLoading) {
    return (
      <div className="h-full">
        <RevSpinner size="large" centered color="primary" />
      </div>
    );
  }

  if (profile && !isLoading) {
    return <ProfileSettingsPage profile={profile} />;
  }
  return null;
};
